import styled from 'styled-components';
import Icon from '../../assets/images/green-tick-icon.svg';

const GreenTickIcon = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 16px 12px;
  display: block;
  position: relative;
  width: 16px;
  height: 12px;
`;

export default GreenTickIcon;
